/**
 * Entrega um arquivo baixado ao navegador, como um download comum.
 *
 * Por blob, e não por `window.open` na rota: o access token vive em memória e vai no
 * `Authorization`, que uma aba nova não envia. E baixar, em vez de abrir: a CSP do painel
 * tem `object-src 'none'`, herdada por documento `blob:` (design D10).
 */
export function salvar(conteudo: Blob, nome: string): void {
  const endereco = URL.createObjectURL(conteudo);
  const ancora = document.createElement("a");
  ancora.href = endereco;
  ancora.download = nome;
  document.body.append(ancora);
  ancora.click();
  ancora.remove();
  // Revogado na volta seguinte do laço: revogar no mesmo tique cancela o
  // download em parte dos navegadores, antes de ele começar a ler o blob.
  setTimeout(() => URL.revokeObjectURL(endereco), 0);
}
